import { Button } from 'components/ui/atoms';
import { Error } from 'components/ui/atoms/icons/Error';
import { cn } from 'lib/utils';
import { AlertDialog } from './alert-dialog';

export type AlertModalProps = {
  isOpen?: boolean;
  message: string;
  title: string;
  buttonText: string;
  onClickButton: () => void;
  className?: string;
};

export const AlertModal = ({
  isOpen,
  title,
  message,
  buttonText,
  onClickButton,
  className,
}: AlertModalProps) => (
  <AlertDialog open={isOpen}>
    <AlertDialog.Content
      aria-description={message}
      className={cn(
        '!tw-p-0 !tw-gap-0 lg:!tw-max-w-[500px] tw-ring-foreground/0 tw-overflow-hidden tw-shadow-modal',
        className,
      )}
    >
      <AlertDialog.Header className="!tw-flex !tw-flex-row !tw-justify-start !tw-items-center tw-bg-[#FCF1F4] tw-py-4 tw-px-6 tw-text-[#AB0D02]">
        <Error data-testid="title-icon" />
        <AlertDialog.Title className="tw-text-lg tw-leading-7 tw-text-start tw-font-bold tw-m-0">
          {title}
        </AlertDialog.Title>
      </AlertDialog.Header>

      <div className="tw-py-3 tw-px-6">
        <p>{message}</p>
      </div>
      <AlertDialog.Footer className="tw-p-4 tw-border-none !tw-m-0">
        <Button variant="danger" onClick={onClickButton}>
          {buttonText}
        </Button>
      </AlertDialog.Footer>
    </AlertDialog.Content>
  </AlertDialog>
);
